<div class="installation-setup">
  <ng-content select="app-installation-setup-header"></ng-content>
  <div class="installation-setup-content">
    <ng-content select="app-installation-setup-content"></ng-content>
  </div>
</div>
